module.exports = new __parcel__URL__("bossfight_battle_missed_image.5b4f4638.png").toString();